export interface SnapTarget { time: number; type: 'frame' | 'clip' | 'marker' | 'playhead' | 'beat'; id?: string }
export interface SnapResult { time: number; snapped: boolean; target?: SnapTarget; delta: number }

export function snapTime(time: number, targets: SnapTarget[], thresholdSeconds: number, fps?: number): SnapResult {
  const all = [...targets];
  if (fps) all.push({ time: Math.round(time * fps) / fps, type: 'frame' });
  let best: SnapTarget | undefined;
  let bestDistance = Infinity;
  for (const target of all) {
    const distance = Math.abs(target.time - time);
    if (distance < bestDistance) { bestDistance = distance; best = target; }
  }
  if (!best || bestDistance > thresholdSeconds) return { time, snapped: false, delta: 0 };
  return { time: best.time, snapped: true, target: best, delta: best.time - time };
}
